<template>
  <div>
    <div class="row">
      <div class="col-xs-12 col-md-12">
        <h2 class="titulo">{{ title }}</h2>
        <div class="row">
          <div class="col-md-3 col-xs-12">
            <ul class="category-list">
              <li>
                <router-link to="/noticias">
                  Todas
                </router-link>
              </li>
              <li v-for="category in categories">
                <router-link :to="getUrlCategory(category.id, category.name)">
                  {{ category.name }}
                </router-link>
              </li>
            </ul>
          </div>
          <div class="col-md-9 col-xs-12">
            <ul id="blogs">
              <li v-for="item in itemsList">
                <router-link :to="getUrl(item.id, item.name)">
                  <img v-if="item.image" :src="item.image"/>
                  <div class="imagem" v-if="!item.image"><img src="dist/images/sem_imagem.jpg"/></div>
                  <span><i class="fa fa-calendar" aria-hidden="true"></i> {{ item.created_at }}
                    <i class="fa fa-clock-o" aria-hidden="true"></i> {{ item.hour_create_at }}</span>
                  <p>{{ item.name }}</p>
                </router-link>
              </li>
            </ul>
          </div>
          <div class="col-md-3 col-xs-12">
          </div>
          <div class="col-md-9 col-xs-12">
            <loading v-if="carregandoNoticias"></loading>
            <button id="buscarNoticias" @click="loadNotices()" class="btn-carregar-mais-noticias">carregar mais
              notícias
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
  import {get} from '../helpers/api';
  import Loading from '../components/common/Loading.vue';
  import {slugify} from '../helpers/slugify';

  export default {
    components: {
      Loading
    },
    data() {
      return {
        showContent: false,
        carregandoNoticias: false,
        page: 1,
        scrolledToBottom: false,
        existMoreData: true,
        categories: [],
        news: [],
        title: 'Notícias',
        selectedCategory: 'all'
      }
    },
    created() {
      let self = this;
      get('categories-news').then(function (response) {
        self.categories = response.data.result.data;
      });
      this.getNews(self.page);
    },
    mounted() {
      if (this.$route.params.categoryId) {
        this.filterItems(this.$route.params.categoryId);
        this.$forceUpdate();
      }
    },
    methods: {
      getNews(page) {
        let self = this;
        self.carregandoNoticias = true;
        if (self.existMoreData) {
          get('news', {'page': page}).then(function (response) {
            //se carregou todas as noticias, não carrega mais
            if (response.data.result.data.length <= 0) {
              self.existMoreData = false;
              self.carregandoNoticias = false;
            }
            response.data.result.data.forEach(function (value) {
              let obj = {
                'id': value.id,
                'image': value.image,
                'created_at': value.created_at,
                'hour_create_at': value.hour_create_at,
                'categoria_id': value.categoria_id,
                'name': value.name,
              };
              self.news.push(obj);
            });
            // = response.data.result.data;
            self.showContent = true;
            self.carregandoNoticias = false;
          });
        }else{
          self.carregandoNoticias = false;
        }
      },
      filterItems(caterogyId) {
        this.selectedCategory = caterogyId;
      },
      getUrl(id, string) {
        return '/noticia/' + id + '/' + slugify(string);
      },
      getUrlCategory(id, string) {
        return '/noticias/' + id + '/' + slugify(string);
      },
      loadNotices() {
        let self = this;
        self.page++;
        self.getNews(self.page);
      }
    },
    computed: {
      itemsList() {
        if (typeof this.news === 'undefined') {
          return [];
        }

        if (this.selectedCategory === 'all') {
          this.$forceUpdate();
          return this.news;
        }

        return this.news.filter(function (obj) {
          return obj.categoria_id == this.selectedCategory;
        }, this).slice();
      }
    },
    watch: {
      $route(to) {
        if (to.params.categoryId) {
          this.filterItems(to.params.categoryId);
        } else {
          this.filterItems('all');
        }
        this.$forceUpdate();
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Blog.vue